var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,1.2246467991473532e-16,-1.2246467991473532e-16,-1,512,512.0000457763672)"
  }, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M321.628,446.372c-63.339,0-122.346-31.372-157.846-83.917c-7.196-10.651-4.394-25.117,6.256-32.313  c10.654-7.194,25.117-4.394,32.313,6.256c26.832,39.717,71.421,63.429,119.277,63.429c79.306,0,143.827-64.521,143.827-143.827  c0-79.307-64.521-143.827-143.827-143.827c-47.998,0-92.66,23.819-119.471,63.716c-7.173,10.67-21.63,13.504-32.298,6.335  c-10.667-7.17-13.503-21.63-6.335-32.298c35.475-52.784,94.579-84.298,158.104-84.298C426.598,65.628,512,151.028,512,256  C512,360.971,426.598,446.372,321.628,446.372z",
    fill: "#5484ff",
    "data-original": "#a9a8ae",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M349.088,232.727H79.458l30.09-30.089c9.089-9.089,9.089-23.824,0-32.912  c-9.087-9.087-23.824-9.087-32.912,0L6.817,239.543c-0.034,0.034-0.062,0.071-0.096,0.105c-0.498,0.504-0.977,1.029-1.429,1.578  c-0.14,0.169-0.258,0.351-0.391,0.523c-0.334,0.428-0.667,0.858-0.97,1.309c-0.099,0.152-0.185,0.313-0.284,0.467  c-0.31,0.489-0.616,0.979-0.892,1.491c-0.061,0.112-0.106,0.231-0.166,0.344c-0.289,0.562-0.568,1.13-0.81,1.716  c-0.033,0.079-0.057,0.163-0.092,0.244c-0.248,0.621-0.483,1.251-0.678,1.898c-0.026,0.087-0.042,0.175-0.067,0.262  c-0.186,0.638-0.355,1.28-0.487,1.939c-0.039,0.199-0.057,0.402-0.092,0.602c-0.096,0.548-0.192,1.095-0.248,1.655  C0.04,254.445,0,255.221,0,256c0,0.779,0.04,1.555,0.116,2.324c0.057,0.568,0.155,1.122,0.251,1.676  c0.034,0.192,0.048,0.389,0.088,0.58c0.133,0.669,0.306,1.322,0.493,1.969c0.023,0.076,0.036,0.157,0.061,0.233  c0.2,0.656,0.436,1.297,0.69,1.93c0.028,0.068,0.048,0.141,0.076,0.209c0.25,0.6,0.534,1.181,0.83,1.753  c0.051,0.101,0.095,0.206,0.147,0.307c0.285,0.529,0.602,1.038,0.923,1.542c0.088,0.137,0.163,0.281,0.251,0.414  c0.321,0.479,0.673,0.936,1.029,1.389c0.113,0.146,0.214,0.299,0.332,0.442c0.483,0.588,0.995,1.153,1.53,1.691l69.815,69.814  c4.544,4.544,10.501,6.817,16.457,6.817s11.913-2.273,16.455-6.817c9.089-9.089,9.089-23.824,0-32.912l-30.089-30.089h269.63  c12.853,0,23.273-10.42,23.273-23.273S361.941,232.727,349.088,232.727z",
    fill: "#1859ff",
    "data-original": "#64c37d",
    className: ""
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log-out.e32bb78f3e47fce3780e939bcba2a112.svg";
export { ForwardRef as ReactComponent };